var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7351 8.99963H9.2684C9.12112 8.99963 9.00171 9.119 9.00171 9.26627V12.733C9.00171 12.8803 9.12112 12.9997 9.2684 12.9997H12.7351C12.8824 12.9997 13.0018 12.8803 13.0018 12.733V9.26627C13.0018 9.119 12.8824 8.99963 12.7351 8.99963Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7334 5H5.26669C5.11942 5 5 5.11936 5 5.26669V8.73339C5 8.88067 5.11942 9.00008 5.26669 9.00008H8.7334C8.88072 9.00008 9.00008 8.88067 9.00008 8.73339V5.26669C9.00008 5.11936 8.88072 5 8.7334 5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7337 5H13.2669C13.1197 5 13.0002 5.11936 13.0002 5.26669V8.73339C13.0002 8.88067 13.1197 9.00008 13.2669 9.00008H16.7337C16.881 9.00008 17.0003 8.88067 17.0003 8.73339V5.26669C17.0003 5.11936 16.881 5 16.7337 5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7334 12.9999H5.26669C5.11942 12.9999 5 13.1192 5 13.2665V16.7333C5 16.8805 5.11942 17 5.26669 17H8.7334C8.88072 17 9.00008 16.8805 9.00008 16.7333V13.2665C9.00008 13.1192 8.88072 12.9999 8.7334 12.9999Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7337 12.9999H13.2669C13.1197 12.9999 13.0002 13.1192 13.0002 13.2665V16.7333C13.0002 16.8805 13.1197 17 13.2669 17H16.7337C16.881 17 17.0003 16.8805 17.0003 16.7333V13.2665C17.0003 13.1192 16.881 12.9999 16.7337 12.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkx);
export default __webpack_public_path__ + "static/media/okx.503c04169780f68f89062d434d36ef6b.svg";
export { ForwardRef as ReactComponent };